import api from '.';
import { PaginationProps } from '../common/interface/pagination';

interface GetContractorParams extends PaginationProps {}

interface CreateContractor {
  name: string;
}

interface UpdateContractor extends CreateContractor {
  id: number | null;
}

interface ShowHideContractor {
  id: number;
  isActive: boolean;
}

export async function getContractors() {
  const { data } = await api.get('/contractors');
  return data;
}

export async function getContractorsMasterData(params: GetContractorParams) {
  const { data } = await api.get('/contractors/master-data', {
    params
  });
  return data;
}

export async function getContractor(id: number) {
  const { data } = await api.get(`/contractors/${id}`);
  return data;
}

export async function createContractor(createContractor: CreateContractor) {
  const { data } = await api.post('/contractors', createContractor);
  return data;
}

export async function updateContractor(updateContractor: UpdateContractor) {
  const { data } = await api.put(
    `/contractors/${updateContractor.id}`,
    updateContractor
  );
  return data;
}

export async function showHideContractor(
  showHideContractor: ShowHideContractor
) {
  const { data } = await api.put(
    `/contractors/${showHideContractor.id}`,
    showHideContractor
  );
  return data;
}

export function deleteContractor(id: number) {
  return api.delete(`/contractors/${id}`);
}
